export const createIdFromHref = (href: string, defaultValue = '', removePath = '') =>
  href.replace(removePath, '').split('/').at(-1) || defaultValue;

export const createUrl = (
  url: RequestInfo | URL,
  params?: string | URLSearchParams | Record<string, unknown> | string[][],
): string => {
  const queryString = new URLSearchParams(params as Record<string, string>).toString();
  return `${url}${queryString && `?${queryString}`}`;
};
